/**
 * THE PRESET FACES OF A SEAT NO KNOWN USER SITS IN — by seat, around the table: a bot, or a human
 * the roster carries no avatar for. One list for every screen that draws seats (حکم, بی‌دل, the
 * waiting room's seats and its team stage), so a chair wears the same face in the room and at the
 * table.
 */
export const PRESET_AVATAR_IDS = ["lion", "wolf", "tiger", "eagle"] as const;

/** The positional preset for `seat` — `"fox"` when `seat % 4` is not 0–3 (e.g. −1, 1.5, NaN) */
export function presetAvatarFor(seat: number): string {
  return PRESET_AVATAR_IDS[seat % PRESET_AVATAR_IDS.length] ?? "fox";
}
